import { SET_WORKOUTS, SET_WORKOUT_BY_ID, RESET_WORKOUT_BY_ID } from './workoutsTypes';

export const setWorkouts = (data) => ({
	type: SET_WORKOUTS,
	payload: data,
});

export const setWorkoutById = (data) => ({
	type: SET_WORKOUT_BY_ID,
	payload: data,
});

export const resetWorkoutById = () => ({
	type: RESET_WORKOUT_BY_ID,
});
